import { handleActions } from "redux-actions";

import {
	getPlayersAsyncAction,
	getTournamentsAsyncAction,
	getPlayerDetailAsyncAction,
	updatePlayerSuspendAsyncAction,
	resetAction,
} from "./playerActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	list: {
		items: [],
		meta: {
			currentPage: 0,
			totalPages: 0,
		},
	},

	fetch: {
		loading: false,
		error: "",
	},

	action: {
		loading: false,
		success: false,
		error: "",
	},

	detail: defaultAjaxState,
	tournaments: defaultAjaxState,
	updateSuspend: defaultAjaxState,
};

export const playerReducer = handleActions(
	new Map([
		[
			getPlayersAsyncAction.request,
			(state) => ({
				...state,
				fetch: {
					...initialState.fetch,
					loading: true,
				},
			}),
		],
		[
			getPlayersAsyncAction.success,
			(state, { payload }) => ({
				...state,
				fetch: {
					...initialState.fetch,
				},
				list: payload,
			}),
		],

		// get tournaments
		[
			getTournamentsAsyncAction.request,
			(state, { payload }) => ({
				...state,
				tournaments: {
					...initialState.tournaments,
					loading: true,
				},
			}),
		],
		[
			getTournamentsAsyncAction.success,
			(state, { payload }) => ({
				...state,
				tournaments: {
					...initialState.tournaments,
					response: payload,
				},
			}),
		],
		[
			getTournamentsAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				tournaments: {
					...initialState.tournaments,
					error: payload,
				},
			}),
		],

		// update player suspend
		[
			updatePlayerSuspendAsyncAction.request,
			(state, { payload }) => ({
				...state,
				updateSuspend: {
					...initialState.updateSuspend,
					loading: true,
				},
			}),
		],
		[
			updatePlayerSuspendAsyncAction.success,
			(state, { payload }) => ({
				...state,
				updateSuspend: {
					...initialState.updateSuspend,
					response: payload,
				},
			}),
		],
		[
			updatePlayerSuspendAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				updateSuspend: {
					...initialState.updateSuspend,
					error: payload,
				},
			}),
		],

		// get detail
		[
			getPlayerDetailAsyncAction.request,
			(state, { payload }) => ({
				...state,
				detail: {
					...initialState.detail,
					loading: true,
				},
			}),
		],
		[
			getPlayerDetailAsyncAction.success,
			(state, { payload }) => ({
				...state,
				detail: {
					...initialState.detail,
					response: payload,
				},
			}),
		],
		[
			getPlayerDetailAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				detail: {
					...initialState.detail,
					error: payload,
				},
			}),
		],

		// reset
		[
			resetAction,
			(state, { payload }) => ({
				...state,
				[payload]: initialState[payload],
			}),
		],
	]),
	initialState
);
